<template>
  <DefScrollbar
    class="modal-aside-body"
    :style="{ maxHeight: `calc(100vh - ${componentHeight}px)` }"
  >
    <slot />
  </DefScrollbar>
</template>

<script lang="ts" setup>
import DefScrollbar from '@components/Def/DefScrollbar/DefScrollbar.vue';
import { onMounted, getCurrentInstance, ref } from 'vue';
// import useScreenWidth from '@use/useScreenWidth';

// const screenWidth = useScreenWidth();
// const componentHeight = ref(screenWidth.value >= 768 ? 48 : 32);
const componentHeight = ref(0);

onMounted(() => {
  // const instance = getCurrentInstance();
  // const root = instance?.parent?.vnode?.el;
  // console.log(instance?.parent);
  // if (root) {
  const header = document.querySelector('.modal-aside-component .modal-aside-header');
  const bottom = document.querySelector('.modal-aside-component .modal-aside-bottom');
  if (header) {
    componentHeight.value += header.getBoundingClientRect().height;
  }
  if (bottom) {
    componentHeight.value += bottom.getBoundingClientRect().height;
  }
  // }
});
</script>

<style lang="scss" scoped>
.modal-aside-body {
  padding: 16px;
  height: 100%;
  @include point-md {
    padding: 24px;
  }
}
</style>
